import { createContext, useContext, useState } from "react";
import useDebounce from "../hooks/useDebounceHook";


const SearchContext=createContext();

export const SearchProvider=({children})=>{
    const [searchTerm,setSearchTerm]=useState('');
    const debounceSearchTerm=useDebounce(searchTerm,500);
    return (
        <SearchContext.Provider value={{searchTerm,setSearchTerm,debounceSearchTerm}}>
            {children}
        </SearchContext.Provider>
    )
}

export function useSearch(){
    return useContext(SearchContext);
}